import React from "react";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import useIsClient from "@default/hooks/use-is-client";
import SliderProvider, {
  useSliderContext,
} from "@default/general-components/slider/context";
import { Slide, Slider } from "@default/general-components/slider/slider";
import CardTeaser from "./card-teaser";
import CardTeaserOverlay from "./card-teaser-overlay";
import UniversalSliderButton from "@default/general-components/universal-slider-button";

const CardSlider = ({ cards }) => {
  const { emblaApi, canScrollPrev, canScrollNext } = useSliderContext();

  return (
    <>
      <UniversalSliderButton
        type="prev"
        onClick={() => emblaApi?.scrollPrev()}
        sliderClassNames={!canScrollPrev ? "slick-disabled" : ""}
      />
      <Slider>
        {cards.map((card, index) => (
          <Slide key={card.id + index}>
            <CardTeaser content={card} index={index} />
          </Slide>
        ))}
      </Slider>
      <UniversalSliderButton
        type="next"
        onClick={() => emblaApi?.scrollNext()}
        sliderClassNames={!canScrollNext ? "slick-disabled" : ""}
      />
    </>
  );
};

const ParagraphCardOverview = ({ content, isMobile }) => {
  const isClient = useIsClient();
  const [searchParams, setSearchParams] = useSearchParams();
  const paramValue = searchParams.get("card-overlay") ?? "";
  const cards = content.fieldCards?.length ? content.fieldCards : [];
  const useStaticGrid = isMobile && cards.length <= 3;
  const activeCard = cards.find(
    (c) => paramValue === String(c.id) || paramValue.startsWith(`${c.id}-`)
  );
  const handleClose = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("card-overlay");
    setSearchParams(next);
  };

  const sectionClassNames = classNames({
    "paragraph paragraph-card-overview": true,
  });

  return (
    <section
      className={sectionClassNames}
      style={
        content.fieldMainColors
          ? { "--card-color": `var(--c-${content.fieldMainColors})` }
          : undefined
      }
    >
      <div className="container">
        {useStaticGrid ? (
          <div className="row">
            {cards.map((card, index) => (
              <div className="col-12" key={card.id + index}>
                <CardTeaser content={card} index={index} />
              </div>
            ))}
          </div>
        ) : (
          <SliderProvider
            options={{
              fade: false,
              autoplay: false,
              align: "start",
              loop: false,
            }}
          >
            <CardSlider cards={cards} />
          </SliderProvider>
        )}
      </div>
      <AnimatePresence>
        {isClient && activeCard && (
          <CardTeaserOverlay
            key={activeCard.id}
            content={activeCard}
            onClose={handleClose}
            color={content.fieldMainColors}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default ParagraphCardOverview;
